import { styled } from '../../../base';

export const StyledLabel = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    marginInlineEnd: theme.spacing(1),
    marginBottom: theme.spacing(1),
    padding: theme.spacing(0.5, 2),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.grey[300]}`,
    color: theme.palette.grey[600],
    backgroundColor: theme.palette.common.white, // Adjust as per your design
    whiteSpace: 'normal',
    wordWrap: 'break-word',
    height: '48px',
}));
